// Translations for src/profiles.ts's FALLBACK_PROFILES fields (label/detail/games/note/inGameHint) and the
// server-driven "Unavailable" fallback note. These are plain string literals, not HTML text nodes, so
// i18n/build.py's page rewriter never sees them -- this is the client-side counterpart, keyed the same way
// (English text -> translation) and looked up by <html lang>, set per generated page by i18n/build.py.
const TABLE: Record<string, Record<string, string>> = {
  de: {
    Battle: "Kämpfen",
    "Record Mixing": "Mix-Vorgänge",
    "Berry Blender": "Beerenmixer",
    "Link cable": "Verbindungskabel",
    "Wireless adapter": "Funkadapter",
    "Ruby · Sapphire · Emerald · FireRed · LeafGreen": "Rubin · Saphir · Smaragd · Feuerrot · Blattgrün",
    "FireRed · LeafGreen · Emerald": "Feuerrot · Blattgrün · Smaragd",
    "Colosseum battles": "Kolosseum-Kämpfe",
    "Ruby · Sapphire · Emerald": "Rubin · Saphir · Smaragd",
    "Red · Blue · Yellow · Gold · Silver · Crystal": "Rot · Blau · Gelb · Gold · Silber · Kristall",
    Unavailable: "Nicht verfügbar",
    "Go upstairs in any Pokémon Center, talk to the attendant on the left and choose the Trade Center.":
      "Gehen Sie in einem Pokémon-Center nach oben, sprechen Sie mit dem Angestellten auf der linken Seite und wählen Sie die Tauschzentrale.",
    "Go upstairs in any Pokémon Center, enter the Union Room (or the wireless Trade Center) and trade with your friend.":
      "Gehen Sie in einem Pokémon-Center nach oben, betreten Sie das Vereinszimmer (oder die drahtlose Tauschzentrale) und tauschen Sie mit Ihrem Freund.",
  },
  fr: {
    Battle: "Combattre",
    "Record Mixing": "Échange de données",
    "Berry Blender": "Mixeur à Baies",
    "Link cable": "Câble de liaison",
    "Wireless adapter": "Adaptateur sans fil",
    "Ruby · Sapphire · Emerald · FireRed · LeafGreen": "Rubis · Saphir · Émeraude · Rouge Feu · Vert Feuille",
    "FireRed · LeafGreen · Emerald": "Rouge Feu · Vert Feuille · Émeraude",
    "Colosseum battles": "Combats du Colisée",
    "Ruby · Sapphire · Emerald": "Rubis · Saphir · Émeraude",
    "Red · Blue · Yellow · Gold · Silver · Crystal": "Rouge · Bleue · Jaune · Or · Argent · Cristal",
    Unavailable: "Indisponible",
    "Go upstairs in any Pokémon Center, talk to the attendant on the left and choose the Trade Center.":
      "Montez à l'étage dans n'importe quel Centre Pokémon, parlez à l'employé de gauche et choisissez le Centre d'Échange.",
    "Go upstairs in any Pokémon Center, enter the Union Room (or the wireless Trade Center) and trade with your friend.":
      "Montez à l'étage dans n'importe quel Centre Pokémon, entrez dans la Salle Union (ou le Centre d'Échange sans fil) et échangez avec votre ami.",
  },
  es: {
    Battle: "Combate",
    "Record Mixing": "Mezcla de registros",
    "Berry Blender": "Licuadora de Bayas",
    "Link cable": "Cable Link",
    "Wireless adapter": "Adaptador inalámbrico",
    "Ruby · Sapphire · Emerald · FireRed · LeafGreen": "Rubí · Zafiro · Esmeralda · Rojo Fuego · Verde Hoja",
    "FireRed · LeafGreen · Emerald": "Rojo Fuego · Verde Hoja · Esmeralda",
    "Colosseum battles": "Combates del Coliseo",
    "Ruby · Sapphire · Emerald": "Rubí · Zafiro · Esmeralda",
    "Red · Blue · Yellow · Gold · Silver · Crystal": "Roja · Azul · Amarilla · Oro · Plata · Cristal",
    Unavailable: "No disponible",
    "Go upstairs in any Pokémon Center, talk to the attendant on the left and choose the Trade Center.":
      "Sube las escaleras en cualquier Centro Pokémon, habla con la persona de la izquierda y elige el Centro de Intercambios.",
    "Go upstairs in any Pokémon Center, enter the Union Room (or the wireless Trade Center) and trade with your friend.":
      "Sube las escaleras en cualquier Centro Pokémon, entra en la Sala Unión (o el Centro de Intercambios inalámbrico) e intercambia con tu amigo.",
  },
  it: {
    Battle: "Battaglia",
    "Record Mixing": "Scambio dati",
    "Berry Blender": "Frullatore di Bacche",
    "Link cable": "Cavo di collegamento",
    "Wireless adapter": "Adattatore wireless",
    "Ruby · Sapphire · Emerald · FireRed · LeafGreen": "Rubino · Zaffiro · Smeraldo · Rosso Fuoco · Verde Foglia",
    "FireRed · LeafGreen · Emerald": "Rosso Fuoco · Verde Foglia · Smeraldo",
    "Colosseum battles": "Battaglie del Colosseo",
    "Ruby · Sapphire · Emerald": "Rubino · Zaffiro · Smeraldo",
    "Red · Blue · Yellow · Gold · Silver · Crystal": "Rossa · Blu · Gialla · Oro · Argento · Cristallo",
    Unavailable: "Non disponibile",
    "Go upstairs in any Pokémon Center, talk to the attendant on the left and choose the Trade Center.":
      "Sali al piano di sopra in un Centro Pokémon qualsiasi, parla con l'impiegato a sinistra e scegli il Centro Scambi.",
    "Go upstairs in any Pokémon Center, enter the Union Room (or the wireless Trade Center) and trade with your friend.":
      "Sali al piano di sopra in un Centro Pokémon qualsiasi, entra nella Sala Unione (o nel Centro Scambi wireless) e scambia con il tuo amico.",
  },
  ja: {
    Battle: "バトル",
    "Record Mixing": "レコードミキシング",
    "Berry Blender": "きのみブレンダー",
    "Link cable": "リンクケーブル",
    "Wireless adapter": "ワイヤレスアダプター",
    "Ruby · Sapphire · Emerald · FireRed · LeafGreen": "ルビー・サファイア・エメラルド・ファイアレッド・リーフグリーン",
    "FireRed · LeafGreen · Emerald": "ファイアレッド・リーフグリーン・エメラルド",
    "Colosseum battles": "コロシアムバトル",
    "Ruby · Sapphire · Emerald": "ルビー・サファイア・エメラルド",
    "Red · Blue · Yellow · Gold · Silver · Crystal": "赤・青・黄・金・銀・クリスタル",
    Unavailable: "利用不可",
    "Go upstairs in any Pokémon Center, talk to the attendant on the left and choose the Trade Center.":
      "ポケモンセンターの2階へ行き、左側の係員に話しかけて通信交換を選びます。",
    "Go upstairs in any Pokémon Center, enter the Union Room (or the wireless Trade Center) and trade with your friend.":
      "ポケモンセンターの2階へ行き、つうしんクラブ（またはワイヤレス通信交換）に入って、友だちと交換します。",
  },
};

// "Trade" and "Coming soon" reuse the exact wording already used elsewhere on each translated page.
TABLE.de.Trade = "Tauschen";
TABLE.fr.Trade = "Échanger";
TABLE.es.Trade = "Intercambia";
TABLE.it.Trade = "Scambia";
TABLE.ja.Trade = "交換";
TABLE.de["Coming soon"] = "Demnächst";
TABLE.fr["Coming soon"] = "Bientôt disponible";
TABLE.es["Coming soon"] = "Próximamente";
TABLE.it["Coming soon"] = "In arrivo";
TABLE.ja["Coming soon"] = "近日公開";

export function trProfile(s: string | undefined): string | undefined {
  if (!s) return s;
  const lang = document.documentElement.lang;
  return TABLE[lang]?.[s] ?? s;
}
